/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import {
  HAZARD_DATA_SUCCESS,
  RUN_STARTED,
  SPEX_SERVICE_SUCCESS,
} from '@hbrisk/sp3-risk-model-support/models/runStatuses.js';
import { withProgressCardFunctionality } from '#components/pages/Models/Model/support/Router/withSectionFunctionality/withSectionLevelStatusIndication/support/ProgressCard/index.js';
import { makeCalculatePercentComplete } from '#components/pages/Models/Model/support/Router/withSectionFunctionality/withSectionLevelStatusIndication/support/ProgressCard/calculatePercentComplete.js';
import RunProgressCard from './RunProgressCard.jsx';

// Input sections stay locked until SPEX finishes, so this card waits for
// SPEX_SERVICE_SUCCESS — two statuses for Type 3, one for building models.
const rateByStatus = {
  [RUN_STARTED]: 1000,
  [HAZARD_DATA_SUCCESS]: 1000,
};

const calculatePercentComplete = makeCalculatePercentComplete(rateByStatus);

const calculateProgressText = percentComplete => {
  if (percentComplete >= 25 && percentComplete < 100) {
    return 'Updating and running model ...';
  }
  if (percentComplete === 100) {
    return 'Model complete ...';
  }
  return '';
};

export { calculatePercentComplete, calculateProgressText };

export default withProgressCardFunctionality({
  calculatePercentComplete,
  calculateProgressText,
  desiredStatus: SPEX_SERVICE_SUCCESS,
})(RunProgressCard);
